import { Icon, Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import CustomTag from "components/Atoms/CustomTag"
import React from "react"
import { getApolloId } from "utils/custom.utils"
function OverFlowTag({ items, icon = null, renderText, className }) {
  return (
    <CustomPopover
      minimal
      position={Position.BOTTOM_LEFT}
      disabled={items.length === 0}
      content={
        <Menu
          style={{
            height: 180,
            overflow: "auto",
          }}
        >
          {items.map(
            v =>
              v && (
                <MenuItem
                  key={getApolloId(v)}
                  text={renderText(v)}
                  icon={icon}
                />
              )
          )}
        </Menu>
      }
    >
      <CustomTag
        interactive
        className={className}
        round
        minimal
        intent="primary"
        icon={<Icon icon="plus" iconSize={10} />}
      >
        {items && items.length}
      </CustomTag>
    </CustomPopover>
  )
}
OverFlowTag.defaultProps = {
  name: "name",
  renderText: item => item.name,
  items: [],
}
export default OverFlowTag
